import React from 'react';
import { roundTo } from "../../../../../../Utils";

const Row = ({ country, clicks, revenues }) => {
    const cpc = roundTo(4, revenues / clicks);

    return (
        <tr>
            <td>{country}</td>
            <td>{cpc}</td>
        </tr>
    );
};

export default Row;


// WEBPACK FOOTER //
// ./src/scenes/BidderCpcCountry/components/Table/components/Row/index.js